// extracted by mini-css-extract-plugin
export default {"root":"CardContainer_root__OzwsB","icon":"CardContainer_icon__m3Kfk"};